export function getTokenFromIframe(params = { type: 'token' }) {
  return listenerMessageResult(data => {
    if (data.type !== params.type) {
      return Promise.resolve('')
    }
    if (data[params.type]) {
      return Promise.resolve(data[params.type])
    }
    return Promise.reject('no token')
  })
}

export function listenerMessageResult(pendingFunc, delay = 1000 * 5) {
  let timer = null

  return new Promise((resolve, reject) => {
    const cleanListener = () => {
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
      window.removeEventListener('message', dealMessage)
    }
    async function dealMessage(event) {
      if (typeof event.data === 'string') {
        return
      }
      const res = await pendingFunc(event.data).catch(error => {
        reject(error)
        cleanListener()
        return
      })
      if (!res) {
        return
      }
      resolve(res)
      cleanListener()
    }
    window.removeEventListener('message', dealMessage)
    window.addEventListener('message', dealMessage)

    timer = setTimeout(() => {
      clearTimeout(timer)
      timer = null
      window.removeEventListener('message', dealMessage)
      reject(new Error('listener message result timeout'))
    }, delay)
  })
}

export function postMessage(data) {
  window.self.parent.postMessage({ ...data, from: 'form' }, '*')
}
